export default "__VITE_ASSET__Bhao5j9b__"